import request from '@/core/request'
import { useToast } from '@/ui-runtime/core/composable/use-toast'
import { useRoute } from 'vue-router'
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'
import { useQuery } from '@tanstack/vue-query'
import { ref, onMounted, computed } from 'vue'
import dayjs from 'dayjs'

export const defaultConfig = {
  key: 'ui-team1', // 每个ui组件必须有
  type: 'ui-team1', //
  images: {
    teamBg: 'team-my-cp-bg',
    teamBeInvitedEntry: 'team-be-invited-entry',
    teamBeInvitedBg: 'team-be-invited-dialog',
    teamButtonAgree: 'team-button-agree',
    teamButtonInvite: 'team-button-invite',
    teamEmptyBg: 'team-empty-bg',
    teamIconRight: 'team-icon-right',
    teamInput: 'team-input',
    teamInviteDialog: 'team-invite-dialog',
    teamInvitedMask: 'team-invited-mask',
    teamYestodayTop1Bg: '',
    teamCpRuleDialog: 'team-cp-rule',
    teamBtnSendInvite: '',
  },
  layout: {
    wrapper: {
      user1Wrapper: {
        wh: '68 68',
        pl: '75',
        pt: '126',
        bdr: '50%',
        bd: '1px solid #FFFFFF',
      },
      user2Wrapper: {
        wh: '68 68',
        pr: '74',
        pt: '126',
        bdr: '50%',
        bd: '1px solid #FFFFFF',
      },
      user1TextWrapper: {
        wh: '130 23',
        pb: '-30',
        f: '11 #2B1600 400',
        pc: 'x',
        lh: '23',
      },
      user2TextWrapper: {
        wh: '130 23',
        pb: '-30',
        f: '11 #2B1600 400',
        pc: 'x',
        lh: '23',
      },
      platformCpWrapper: {
        wh: '154 48',
        pc: 'x',
        pt: '160',
      },
      platformCpAvatarWrapper: {
        wh: '48',
        p: 'relative',
        bdr: '50%',
        bd: '1px solid #F48BA8',
      },
      recommendCpWrapper: {
        wh: '234 48',
        pc: 'x',
        pt: '160',
      },
      recommendCpAvatarWrapper: {
        wh: '48',
        p: 'relative',
        bdr: '50%',
        bd: '1px solid #F48BA8',
      },
      recommendCpNicknameWrapper: {
        f: '12 #333333 400',
        wh: '80 16',
        pc: 'x',
        pt: '48',
        tc: 'center',
      },
      recommendCpIconRightWrapper: {
        wh: '12',
        pt: '0',
        pr: '0',
        bgS: 'contain',
        bgR: 'no-repeat',
      },
      recommendCpInviteButtonWrapper: {
        wh: '74 30',
        pc: 'x',
        pt: '229',
      },
      recommendCpInputWrapper: {
        wh: '166 36',
        pc: 'x',
        pt: '313',
      },
      recommendCpInputInnerWrapper: {
        wh: '70 17',
        pl: '13',
        pt: '9',
        fs: '14',
        fc: 'rgba(0, 0, 0, 1)',
        fw: '400',
      },
      recommendCpInputSearchWrapper: {
        wh: '73 100%',
        pr: '0',
      },
      searchResultWrapper: {
        wh: '186 38',
        pc: 'x',
        pb: '84',
      },
      searchResultAvatarWrapper: {
        wh: '38',
        pl: '0',
        pc: 'y',
        bdr: '50%',
      },
      searchResultNicknameWrapper: {
        f: '12 #333333 400',
        wh: '100 16',
        pl: '42',
        pc: 'y',
      },
      searchResultButtonWrapper: {
        wh: '74 30',
        pl: '140',
        pc: 'y',
      },
      beInvitedEntryWrapper: {
        pt: '100',
      },
      beInvitedDialogWrapper: {
        wh: '296 218',
        pc: 'x',
        pt: '80',
      },
      beInvitedItemWrapper: {
        wh: '296 58',
        p: 'relative',
        mb: '10',
      },
      beInvitedItemAvatarWrapper: {
        wh: '32',
        pl: '9',
        pc: 'y',
        bdr: '50%',
      },
      beInvitedItemNicknameWrapper: {
        f: '14 #333333 400',
        wh: '150 16',
        pl: '45',
        pt: '13',
      },
      beInvitedItemTextWrapper: {
        f: '11 #333333 400',
        wh: '150 14',
        pl: '45',
        pb: '12',
      },
      beInvitedItemButtonWrapper: {
        wh: '74 30',
        pr: '9',
        pc: 'y',
      },
      chipWrapper: {
        wh: '78 17',
        pl: '155',
        pt: '85',
        f: '14 #8D190C 600',
      },
      questionIconWrapper: {
        wh: '40 30',
        pl: '220',
        pt: '-40',
      },
      taskClickWrapper: {
        wh: '74 36',
        pl: '232',
        pt: '76',
      },
      teamYestodayTop1Wrapper: {
        wh: '36',
        pl: '0',
        pt: '0',
      },
      teamYestodayTop2Wrapper: {
        wh: '36',
        pl: '34',
        pt: '0',
      },
      teamBtnSendInviteWrapper: {
        wh: '86 63',
        pc: 'x',
        pb: '42',
      },
      closeBtnWrapper: {
        wh: '40',
        pr: '0',
        pt: '20',
      },
    },
  },
  config: {
    searchApi: '/api/activities/general/cp/search',
    recommendApi: '/api/activities/general/cp/recommend',
    inviteApi: '/api/activities/general/cp/invite',
    beInvitedApi: '/api/activities/general/cp/invite/list',
    acceptInviteApi: '/api/activities/general/cp/accept',
    cpInfoApi: '/api/activities/general/cp/my/info',
    getChipApi: '/api/activities/general/points',
    chipKey: 'point1_total',
    emptyNickname: '虚位以待',
    cpRuleDialogName: 'teamCpRuleDialog',
    searchPlaceholder: '输入ID',
    inviteText: '邀请你绑定成为七夕活动cp',
    taskDialogKey: 'task',
  },
}

export type UseTeamOptions = {
  /** 仅 ui-team1：拉花瓣、首进自动弹邀请（与 inviteDialog / cpInfoData 同实例） */
  mountSideEffects?: boolean
  /** 仅 ui-be-invited：带 ?invited 时自动打开被邀请弹窗（与 beInvitedDialog 同实例） */
  mountInvitedDeepLink?: boolean
}

export const useTeam = (uiMeta: any, options?: UseTeamOptions) => {
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const { $dialogs } = useDialogs()
  const { $toast } = useToast()
  const searchUserData = ref(null)
  const cpInfoData = ref(null)
  const selectedCp = ref(null)

  const { data: myInfo } = useQuery({
    queryKey: ['myInfo'],
    queryFn: () => {
      return request.get(uiMeta.config.cpInfoApi, {
        activity_code,
      })
    },
  })

  const handleInviteOpen = async () => {
    if (myInfo.value?.data?.my_cp_info?.user2?.public_id) {
      return
    }

    const res = await request.get(uiMeta.config.recommendApi, {
      activity_code,
    })
    if (res.status === 0) {
      cpInfoData.value = res.data
      $dialogs['inviteDialog'].open({
        data: res.data,
      })
    } else {
      $toast.show((res as any)?.msg || '获取推荐数据失败')
    }
  }

  const inviteCpData = async (type = 'recommend') => {
    let id = null

    if (type === 'recommend') {
      const cp = (cpInfoData.value as any)?.platform_cp
      id = cp != null ? (cp as any).public_id : selectedCp.value
    } else {
      id = (searchUserData.value as any)?.public_id
    }

    if (!id) {
      return
    }

    const res = await request.post(uiMeta.config.inviteApi, {
      public_id: id,
      activity_code,
    })
    if (res.status === 0) {
      $toast.show('邀请成功')
      $dialogs['inviteDialog'].close()
    } else {
      $toast.show((res as any)?.msg || '邀请失败')
    }
  }

  const doSearchUser = async (searchId: string) => {
    const res = await request.get(uiMeta.config.searchApi, {
      public_id: searchId,
    })
    if (res.status === 0) {
      searchUserData.value = res.data.user
    } else {
      searchUserData.value = null
      $toast.show((res as any)?.msg || '搜索失败')
    }
  }

  const acceptCpInviteData = async (id: string) => {
    const res = await request.post(uiMeta.config.acceptInviteApi, {
      invite_id: id,
      activity_code,
    })
    if (res.status === 0) {
      $toast.show('接受邀请成功')
      $dialogs['beInvitedDialog'].close()
    } else {
      $toast.show((res as any)?.msg || '接受邀请失败')
    }
  }

  const handleBeInvitedOpen = async () => {
    const res = await request.get(uiMeta.config.beInvitedApi, {
      activity_code,
    })

    if (res.status === 0) {
      $dialogs['beInvitedDialog'].open({
        data: {
          inviteListData: res.data.invite_records,
        },
      })
    }
  }

  const chipData = ref<number>(0)
  const getChipData = async () => {
    const res = await request.get(uiMeta.config.getChipApi, {
      activity_code,
    })
    if (res.status === 0) {
      chipData.value = res.data[uiMeta.config.chipKey]
      return res.data[uiMeta.config.chipKey]
    }
  }

  const handleCpRuleOpen = () => {
    $dialogs[uiMeta.config.cpRuleDialogName].open()
  }

  const handleTaskOpen = () => {
    $dialogs[uiMeta.config.taskDialogKey].open()
  }

  const isShowBeInvited = computed(() => {
    // has_cp_invite
    return !myInfo.value?.data?.my_cp_info?.user2?.public_id && myInfo.value?.data?.has_cp_invite
  })

  const yesterdayTopData = computed(() => {
    return myInfo.value?.data?.yesterday_top
  })

  onMounted(async () => {
    if (options?.mountSideEffects) {
      void getChipData()

      // 主动弹出组队逻辑 每天只弹出一次（仅持有 inviteDialog 的 ui-team1 执行，避免写错 cpInfoData 实例）
      const key = `${activity_code}-team-invite-${dayjs().format('YYYY-MM-DD')}`

      setTimeout(() => {
        if (!myInfo.value?.data?.my_cp_info?.user2?.public_id && !localStorage.getItem(key)) {
          handleInviteOpen()
          localStorage.setItem(key, 'true')
        }
      }, 1000)
    }

    if (options?.mountInvitedDeepLink) {
      const { invited } = route.query
      setTimeout(() => {
        if (invited && !myInfo.value?.data?.my_cp_info?.user2?.public_id) {
          handleBeInvitedOpen()
        }
      }, 1200)
    }
  })

  return {
    myInfo,
    handleInviteOpen,
    inviteCpData,
    doSearchUser,
    searchUserData,
    selectedCp,
    acceptCpInviteData,
    chipData,
    getChipData,
    handleCpRuleOpen,
    handleTaskOpen,
    handleBeInvitedOpen,
    isShowBeInvited,
    yesterdayTopData,
  }
}
